import { createThemeSelector } from './utils'

export const paletteSelector = createThemeSelector(theme => theme.palette)

export const paletteCommonSelector = createThemeSelector(
  paletteSelector,
  palette => palette.common
)

export const palettePrimarySelector = createThemeSelector(
  paletteSelector,
  palette => palette.primary
)

export const paletteSecondarySelector = createThemeSelector(
  paletteSelector,
  palette => palette.secondary
)

export const paletteGreySelector = createThemeSelector(
  paletteSelector,
  palette => palette.grey
)

export const paletteTextSelector = createThemeSelector(
  paletteSelector,
  palette => palette.text
)

export const paletteBackgroundSelector = createThemeSelector(
  paletteSelector,
  palette => palette.background
)

export const paletteSuccessSelector = createThemeSelector(
  paletteSelector,
  palette => palette.success
)

export const paletteErrorSelector = createThemeSelector(
  paletteSelector,
  palette => palette.error
)

export const paletteWarnSelector = createThemeSelector(
  paletteSelector,
  palette => palette.warn
)

export const paletteDividerSelector = createThemeSelector(
  paletteSelector,
  palette => palette.divider
)

export const paletteTypeSelector = createThemeSelector(
  paletteSelector,
  palette => palette.type
)

export const paletteActionSelector = createThemeSelector(
  paletteSelector,
  palette => palette.action
)

export const paletteTextImageFilterSelector = createThemeSelector(
  paletteSelector,
  palette => palette.textImageFilter
)
